export enum AuditAction {
  EntityCreated = 'entity.created',
  EntityUpdated = 'entity.updated',
  EntityDeleted = 'entity.deleted',
  EntityDuplicated = 'entity.duplicated',
  OrderStatusChanged = 'order.status_changed',
  ProductionStageChanged = 'production.stage_changed',
  JobOrderPrinted = 'job_order.printed',
}

export const AUDIT_ACTION_LABELS: Record<AuditAction, string> = {
  [AuditAction.EntityCreated]: 'Entity created',
  [AuditAction.EntityUpdated]: 'Entity updated',
  [AuditAction.EntityDeleted]: 'Entity deleted',
  [AuditAction.EntityDuplicated]: 'Entity duplicated',
  [AuditAction.OrderStatusChanged]: 'Order status changed',
  [AuditAction.ProductionStageChanged]: 'Production stage changed',
  [AuditAction.JobOrderPrinted]: 'Job order printed',
};

export const AUDIT_ACTION_FILTER_OPTIONS: {
  value: AuditAction;
  label: string;
}[] = Object.values(AuditAction).map((value) => ({
  value,
  label: AUDIT_ACTION_LABELS[value],
}));
